const PARTNER_SERVICE_PARTNER_ATTRIBUTES = [
    'id',
    'name',
    'email',
    'status',
    'contact',
    'details',
    'emails',
    'vat_payer',
    'legal_entity_type',
    'inn',
    'kpp',
    'legal_address',
    'bank_credentials',
];

const toNullableNumber = value => {
    if (value === '' || value == null) {
        return null;
    }

    const parsedValue = Number(value);
    return Number.isInteger(parsedValue) ? parsedValue : null;
};

const toNullableDateTime = value => {
    if (value == null || value === '') {
        return null;
    }

    const date = value instanceof Date ? value : new Date(value);

    return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

export const normalizePartnerContractData = data => {
    const result = { ...data };

    if (Object.prototype.hasOwnProperty.call(result, 'partner_id')) {
        result.partner_id = toNullableNumber(result.partner_id);
    }
    if (Object.prototype.hasOwnProperty.call(result, 'owner_partner_service_id')) {
        result.owner_partner_service_id = toNullableNumber(result.owner_partner_service_id);
    }
    if (Array.isArray(result.visible_partner_services)) {
        result.visible_partner_services = result.visible_partner_services
            .filter(rule => rule && toNullableNumber(rule.partner_service_id) !== null)
            .map(rule => ({
                partner_service_id: toNullableNumber(rule.partner_service_id),
                sessions_visible_from: toNullableDateTime(rule.sessions_visible_from),
            }));
    }

    delete result.partner;
    delete result.owner_partner_service;
    delete result.created;
    delete result.updated;

    return result;
};

export const normalizePartnerData = (data, permissions) => {
    const result = {
        ...data,
        emails:
            data.emails && data.emails.length
                ? data.emails
                      .filter(Boolean)
                      .map(emailValue =>
                          typeof emailValue === 'string' ? emailValue : emailValue.email
                      )
                      .filter(Boolean)
                : null,
    };

    if (permissions === 'partner_service') {
        return PARTNER_SERVICE_PARTNER_ATTRIBUTES.reduce((partner, attribute) => {
            if (Object.prototype.hasOwnProperty.call(result, attribute)) {
                partner[attribute] = result[attribute];
            }
            return partner;
        }, {});
    }

    if (Object.prototype.hasOwnProperty.call(result, 'franchisee_id')) {
        result.franchisee_id = toNullableNumber(result.franchisee_id);
    }
    if (Object.prototype.hasOwnProperty.call(result, 'agent_id')) {
        result.agent_id = toNullableNumber(result.agent_id);
    }
    if (Object.prototype.hasOwnProperty.call(result, 'partner_service_id')) {
        result.partner_service_id = toNullableNumber(result.partner_service_id);
    }

    return result;
};
